function Home () {
  return (
    <main role='main' className='inner cover'>
      <h1 className='cover-heading title'>Mikulášské odpoledne</h1>
      <span className='underline-animation' />
      <div className='fade-down'>
        <p className='lead description'>Zarezervujte si svoje lístky ještě dnes.</p>
      </div>
    </main>
  )
}

export default Home
